export default {
    data() {
        return {
            profile: 'As an experimental PhD in Physics, one of the most important aspects was data analysis. I really enjoyed how we can obtain results and conclusions from raw data. I am open to learn new things concerning coding, statistics or math.',
            experienceUAMTitle: 'Researcher at Universidad Autonoma de Madrid',
            experienceUAMTitleMob: 'Researcher at U. Autonoma de Madrid (2015-2019)',
            experienceUAM: [
                'Design and built a device from scratch. Mechanics, electronics and computer communications',
                'Development of a full software to manage, clean and analyze raw experimental data',
                'Presentation of results at international conferences and high impact scientific journals'
            ],
            education: [
                { fecha: '2015 - 2019', texto: 'PhD cum laude in Condensed Matter Physics and Nanotechnology: Vortex Lattices under Stress.' },
                { fecha: '2014 - 2015', texto: 'Master’s degree in Condensed Matter Physics and Nanotechnology.' },
                { fecha: '2008-2013', texto: '5 year degree in Physics.' }
            ],
            skillsCol1: [
                'Python',
                'Matlab',
                'SQL',
                'HTML, CSS, Javascript'
            ],
            skillsCol2: [
                'Git, Github',
                'AWS',
                'Spark (scala)'
            ],
            languages: [
                'Spanish: Native',
                'English: C1',
                'German: A1'
            ],
            coursesML: [
                'Intermediate Machine Learning - Kaggle',
                'Feature Engineering - Kaggle',
                'Machine Learning: Data Science en Python - Udemy',
                'Machine Learning - Coursera'
            ],
            coursesScala: [
                'Functional Programming Principles in Scala - Coursera',
                'Big Data Analysis with Scala and Spark - Coursera'
            ],
            coursesSQL: ['Intro to SQL - Kaggle'],
            coursesNLP: ['Natural Language Processing - Kaggle'],
            conferences: [
                '¿Quieres ser un data scientist? organized by IMMUNE. 2nd prize inits DATATHON',
                'AWS Summit Online'
            ]
        }
    }
}
